import { Heading } from '@chakra-ui/react';
import { IGetSubscriptionSchema } from '@monetize/types/app';
import { FiExternalLink } from 'react-icons/fi';
import { MFormField, MIcon, MIDCopyBox, MLink } from '..';
import { ROUTES } from '../../../constants';
import { getProductEditRoute } from '../../../constants/routes';
import { SubscriptionBillingStatusDisplayText } from '../../../constants/subscriptions';
import { MEntityStatusBadge } from '../MEntityStatusBadge';
import { RecordLookupPopover } from './RecordLookupPopover';

export interface SubscriptionLookupPopoverProps {
  value: string;
  record: { usageTypeId: string };
}

export function SubscriptionLookupPopover({
  value,
  record: { usageTypeId },
}: SubscriptionLookupPopoverProps) {
  if (!value) {
    return null;
  }

  return (
    <RecordLookupPopover
      recordId={value}
      endpoint={`/api/subscriptions/${value}`}
      renderRecord={(record) => {
        const subscription = record as IGetSubscriptionSchema;
        const subscriptionItem = subscription.subscriptionItems.find((item) =>
          item.product.usageTypes?.find(({ id }) => id === usageTypeId),
        );
        const usageType = subscriptionItem?.product.usageTypes?.find(
          ({ id }) => id === usageTypeId,
        );
        return (
          <>
            <Heading as="h3" size="sm" mb={1}>
              {subscription.offering.name}
              <MEntityStatusBadge
                status={
                  SubscriptionBillingStatusDisplayText[
                    subscription.billingStatus
                  ]
                }
              />
            </Heading>
            <MIDCopyBox copyValue={subscription.id} />
            <MFormField label="Account" isHorizontal>
              <MLink
                href={ROUTES.getAccountUsageRoute(subscription.account.id)}
                target="_blank"
                rel="noopener noreferrer"
                fontWeight="400"
                whiteSpace="normal"
                fontSize="sm"
              >
                {subscription.account.name}
                <MIcon as={FiExternalLink} ml="1" color="tIndigo.base" />
              </MLink>
            </MFormField>
            <MFormField label="Bill Group" isHorizontal>
              <MLink
                href={ROUTES.getBillGroupPageRoute(subscription.billGroupId)}
                target="_blank"
                rel="noopener noreferrer"
                fontWeight="400"
                whiteSpace="normal"
                fontSize="sm"
              >
                {subscription.billGroupId}
                <MIcon as={FiExternalLink} ml="1" color="tIndigo.base" />
              </MLink>
            </MFormField>
            {subscriptionItem && usageType && (
              <>
                <MFormField label="Product" isHorizontal>
                  <MLink
                    href={getProductEditRoute(subscriptionItem.product.id)}
                    target="_blank"
                    rel="noopener noreferrer"
                    fontWeight="400"
                    whiteSpace="normal"
                    fontSize="sm"
                  >
                    {subscriptionItem.product.name}
                    <MIcon as={FiExternalLink} ml="1" color="tIndigo.base" />
                  </MLink>
                </MFormField>
                <MFormField label="Usage Type" isHorizontal>
                  <MLink
                    href={ROUTES.getUsageTypeEditRoute(usageType.id)}
                    target="_blank"
                    rel="noopener noreferrer"
                    fontWeight="400"
                    whiteSpace="normal"
                    fontSize="sm"
                  >
                    {usageType.name}
                    <MIcon as={FiExternalLink} ml="1" color="tIndigo.base" />
                  </MLink>
                </MFormField>
              </>
            )}
          </>
        );
      }}
    >
      {value}
    </RecordLookupPopover>
  );
}
